export default class AppUserInformationState {
    public displayName: string;
    public profilePhoto: string;
    public totalApps: number;
    public isAuthenticated: boolean;

    constructor(isAuthenticated: boolean = false, displayName: string = "Anonymous", profilePhoto: string = "", totalApps: number = 0) {
        this.totalApps = totalApps;
        this.displayName = displayName;
        this.profilePhoto = profilePhoto;
        this.isAuthenticated = isAuthenticated;
    }
}